export { default } from './Toolbar';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/Toolbar/index.js